import axios from 'axios';

import { LlavesEndPointServicios } from "../Configuracion/Llaves/RepositorioConfig";

const InstanciaPublica = axios.create();
InstanciaPublica.defaults.baseURL = LlavesEndPointServicios.UrlServicioSeguridad;

InstanciaPublica.CancelToken = axios.CancelToken;
InstanciaPublica.isCancel = axios.isCancel;

//objeto que representa las peticiones genericas
const requestGenericoPublico = {
    get: (url) => InstanciaPublica.get(url),
    post: (url, body) => InstanciaPublica.post(url, body),
    put: (url, body) => InstanciaPublica.put(url, body),
    delete: (url) => InstanciaPublica.delete(url)
};

//objeto que representa la instancia publica que no requiere login
export default requestGenericoPublico;